import { ALargeSmallIcon } from 'lucide-react'
import { useT } from '@/session/useSession'
import { isTextSize, TEXT_SIZES, useTheme } from '@/session/useTheme'
import { IconButton } from '../IconButton/IconButton'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu'

export function TextSizeToggle() {
  const t = useT()
  const { textSize, setTextSize } = useTheme()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <IconButton label={t('text_size.legend')}>
            <ALargeSmallIcon />
          </IconButton>
        }
      />
      <DropdownMenuContent align="end">
        <DropdownMenuRadioGroup
          value={textSize}
          onValueChange={(next) => {
            if (isTextSize(next)) setTextSize(next)
          }}
        >
          {TEXT_SIZES.map((option) => (
            <DropdownMenuRadioItem key={option} value={option}>
              {t(`text_size.${option}.name`)}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
